var _path, _circle, _path2, _rect, _rect2, _rect3, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 980 700",
    fill: "#393939",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0h860c33.1 0 60 26.9 60 60v480c0 33.1-26.9 60-60 60H60c-33.1 0-60-26.9-60-60V60C0 26.9 26.9 0 60 0zm0 50c-5.5 0-10 4.5-10 10v480c0 5.5 4.5 10 10 10h860c5.5 0 10-4.5 10-10V60c0-5.5-4.5-10-10-10H60z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 210,
    r: 80,
    stroke: "#393939",
    strokeWidth: 50,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160 420c0-77 63-140 140-140s140 63 140 140",
    stroke: "#393939",
    strokeWidth: 50,
    fill: "none",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 180,
    width: 280,
    height: 40,
    rx: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 270,
    width: 280,
    height: 40,
    rx: 20
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 360,
    width: 200,
    height: 40,
    rx: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140 600c0-30 24-54 54-54s54 24 54 54v100H140V600z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M310 600c0-30 24-54 54-54s54 24 54 54v100H310V600z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M480 600c0-30 24-54 54-54s54 24 54 54v100H480V600z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M650 600c0-30 24-54 54-54s54 24 54 54v100H650V600z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCardIcon);
export default __webpack_public_path__ + "static/media/contact-card-icon.a39298ea.svg";
export { ForwardRef as ReactComponent };